import ScrollToTop from '../Components/ScrollToTop';
import HeroSection6 from '../Components/HeroSection6/index6';
import InfoSection5 from '../Components/Infosection5/Index5';
import { homeObjOne5 } from '../Components/Infosection5/Data5';
import Footer from '../Components/Footer/Footer';



const OmOss = () => {
  return (
    <>
      <ScrollToTop />
      <HeroSection6 />
      <InfoSection5 {...homeObjOne5} />
  
      <Footer />
    </>
  )
}

export default OmOss